import React from "react";

import AppComponent from "../../Components/AppComponent";
import { Table, Button } from "react-bootstrap";
import ScrollListener from "../../Components/eventListeners/ScrollListener";
import WindowScrollListener from "../../Components/eventListeners/WindowScrollListener";
import ReactToPrint from "react-to-print";

class AppTable extends AppComponent {
  componentRef = React.createRef(null);

  get renderTable() {
    const {
      props: { items, table = {} },
    } = this;

    return (
      <div className="tablewrapper">
        <Table className="itemstable" striped hover bordered>
          <tbody>
            <tr>
              {table.columns?.map((x) => (
                <th key={x.value} style={x?.styles?.th}>{x.label}</th>
              ))}
            </tr>

            {items?.map((item, index) => (
              <ItemRow
                key={item._id || index}
                item={item}
                index={index}
                table={table}
              />
            ))}
          </tbody>
        </Table>
      </div>
    );
  }

  reactToPrintTrigger = () => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button size="sm" variant="secondary">
          Print
        </Button>
      </div>
    );
  };

  render() {
    const {
      props: { items, loading = false, error = null, onScrollEnd },
    } = this;

    return (
      <>
        {this.componentRef.current ? (
          <ReactToPrint
            content={() => this.componentRef.current}
            documentTitle={`tn-list`}
            // onAfterPrint={this.handleAfterPrint}
            // onBeforeGetContent={this.handleOnBeforeGetContent}
            // onBeforePrint={this.handleBeforePrint}
            removeAfterPrint
            trigger={this.reactToPrintTrigger}
          />
        ) : null}

        <div className="itemlist" ref={this.componentRef}>
          {error ? <div className="errormsg">{error}</div> : null}

          {loading ? (
            <div className="barloader">
              <div className="bar" />
            </div>
          ) : null}

          {this.props.renderTable
            ? this.props.renderTable({ items })
            : this.renderTable}

          {!items?.length && !loading ? (
            <div className="nothingbox nothingpadded">
              <div className="nothingdecor">
                <div className="nothing one"></div>
                <div className="nothing two"></div>
              </div>
              <div className="nothingline">Nothing to show here</div>
            </div>
          ) : null}

          {items.length && loading ? (
            <div className="barloader">
              <div className="bar" />
            </div>
          ) : null}
        </div>

        {onScrollEnd ? (
          this.props.scrollSelector ? (
            <ScrollListener
              onWindowScroll={console.log}
              onScrollEnd={onScrollEnd}
              // elRef={this.elRef}
              scrollSelector={this.props.scrollSelector || ""}
            />
          ) : (
            <WindowScrollListener
              onWindowScroll={console.log}
              onScrollEnd={onScrollEnd}
            />
          )
        ) : null}
      </>
    );
  }
}

class ItemRow extends AppComponent {
  render() {
    const {
      props: { item, index, table = {} },
    } = this;

    if (!item) return null;

    return (
      <>
        <tr
          onClick={() => table?.onRowClick?.({ item, index })}
          className={`${table?.onRowClick ? "pointer" : ""}`}
          style={table?.getStyle ? table.getStyle({ item, index }) : null}
        >
          {table.columns?.map((col) => {
            return (
              <td key={col.value} style={col?.styles?.td}>
                {col.render ? col.render({ item, index }) : item[col.value]}
              </td>
            );
          })}
        </tr>
      </>
    );
  }
}

export default AppTable;
